import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { CultureService } from '../../services/culture.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-external-docs-message',
    templateUrl: './se-external-docs-message.component.html',
    styleUrls: ['./se-external-docs-message.component.scss'],
    standalone: false
})
export class SeExternalDocsMessageComponent {
    @HostBinding('class')
    className = 'se-external-docs-message';

    @Input()
    isOnError: boolean;

    @Input()
    isDeletingDoc: boolean;

    @Input()
    messageBoxText: string;

    @Input()
    isConfirmedOp: boolean;

    @Output()
    cancelOpsRequired = new EventEmitter();

    @Output()
    confirmOpsRequired = new EventEmitter();

    constructor(private culture: CultureService, private translate: TranslateService) { }

    public onCancelOps(ops) {
        this.cancelOpsRequired.emit(ops);
    }

    public onConfirmOps(ops) {
        this.confirmOpsRequired.emit(ops);
    }

    public onEnterKeyDown(e) {
        if (this.isDeletingDoc)
            this.onConfirmOps('delete');
        else if (this.isOnError || this.isConfirmedOp)
            this.onConfirmOps('closeMessageBox');
    }
}
